export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyCNyVN0ViYSzze_y61DU76g8t6Rn3d5SEQ',
    authDomain: 'cx-call-center-pos.firebaseapp.com',
    projectId: 'cx-call-center-pos',
    storageBucket: 'cx-call-center-pos.appspot.com',
    messagingSenderId: '196936459806',
    appId: '1:196936459806:web:75df92e20a5e5b2662300f',
    measurementId: 'G-KNK3T8CRH3',
  },
  FunctionURL: 'https://qa-cc-vendor.craftingcodes.org',
  connectToEmulator: false,
};
